import { useQuery } from "react-query";
import ApiService from "../services/ApiService";

export type OrganizationAuthStatus = Record<
  string,
  { valid: boolean; error?: string }
>;

export const useOrganizationAuthCheck = () => {
  return useQuery({
    queryKey: ["organizationAuthCheck"],
    queryFn: async () => {
      const response = await ApiService.fetch<{ data: OrganizationAuthStatus }>(
        "GET",
        "/api/config/organization/auth_check"
      );
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
};
